import React, { useEffect, useState } from 'react';
import EditForm from './components/EditForm';
import NotificationsTable from './components/NotificationsTable';
import DeleteModal from './components/DeleteModal';
import { connect } from 'react-redux';
import { newNotification } from 'actions/uiActions';
import Notifications from 'components/Notifications';
import {
  AddNotificationRow,
  DeleteNotificationRow,
  UpdateNotificationRow,
  getNotificationsRow
} from '../../utils/notificationUtils';

const AutomaticNotifications = ({ cellId, notify }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [rowValue, setRowValue] = useState<NotificationRow>();
  const [rows, setRows] = useState<NotificationRow[]>();
  const [timeSegmentFilter, setTimeSegmentFilter] = useState<TimeSegment>(
    undefined
  );
  const [activeFilter, setActiveFilter] = useState<boolean | undefined>(
    undefined
  );
  const [pgUpdate, setPgUpdate] = useState(0);

  useEffect(() => {
    const setNotifications = async () => {
      setRows(await getNotificationsRow(notify));
    };
    setNotifications();
  }, [pgUpdate]);

  const SendNotificationToDatabase = async (
    isInsert: boolean,
    rowValue: NotificationRow
  ) => {
    if (isInsert) {
      await AddNotificationRow(rowValue, notify);
    } else {
      await UpdateNotificationRow(rowValue, notify);
    }
    setOpenModal(false);
    setOpenAddModal(false);
    setPgUpdate(Math.random());
  };

  const deleteData = async (id: number) => {
    await DeleteNotificationRow(id, notify);
    setPgUpdate(Math.random());
  };

  const FilterNotifications = (): NotificationRow[] => {
    let newRows = rows;
    if (!newRows) {
      return [];
    }
    if (timeSegmentFilter) {
      newRows = newRows.filter(row => {
        return row.time_segment === timeSegmentFilter;
      });
    }
    if (activeFilter) {
      newRows = newRows.filter(row => {
        return row.active === activeFilter;
      });
    }
    newRows = newRows.filter(row => {
      return row.cell_id === cellId;
    });

    return newRows;
  };

  const ClearFilters = () => {
    setActiveFilter(undefined);
    setTimeSegmentFilter(undefined);
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="flex justify-between">
        <div className="flex justify-start gap-2">
          <select
            className="border border-gray-300 p-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 "
            onChange={event => {
              setActiveFilter(parseInt(event.target.value) > 0);
            }}
            value={
              activeFilter === undefined ? undefined : activeFilter ? 1 : 0
            }>
            <option disabled selected>
              Active
            </option>
            <option value={1}>True</option>
            <option value={0}>False</option>
          </select>

          <select
            className="border border-gray-300 p-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 "
            onChange={event => {
              setTimeSegmentFilter(event.target.value as TimeSegment);
            }}
            value={timeSegmentFilter}>
            <option disabled selected>
              Time Segment
            </option>
            <option value={'morning'}>Morning</option>
            <option value={'lunchtime'}>Lunchtime</option>
            <option value={'afternoon'}>Afternoon</option>
            <option value={'night'}>Night</option>
          </select>
          {activeFilter !== undefined || timeSegmentFilter ? (
            <button
              className="justify-self-end text-mannablue-default "
              onClick={() => {
                ClearFilters();
              }}>
              Clear Filters
            </button>
          ) : (
            ''
          )}
        </div>

        <button
          className="justify-self-end p-2 bg-mannablue-default text-white rounded-lg "
          onClick={() => setOpenAddModal(true)}>
          Add new Notification +
        </button>
      </div>

      <NotificationsTable
        rows={FilterNotifications()}
        rowValues={setRowValue}
        setOpenEditModal={setOpenModal}
        setOpenDeleteModal={setOpenDeleteModal}></NotificationsTable>
      {
        <EditForm
          onClose={() => setOpenAddModal(false)}
          modal={openAddModal}
          row={{
            title: '',
            message: '',
            time_segment: 'morning' as TimeSegment,
            active: false,
            cell_id: cellId
          }}
          submitHandler={row => SendNotificationToDatabase(true, row)}
        />
      }
      {rowValue ? (
        <EditForm
          onClose={() => setOpenModal(false)}
          modal={openModal}
          row={rowValue}
          submitHandler={row => SendNotificationToDatabase(false, row)}
        />
      ) : (
        ''
      )}
      {openDeleteModal && (
        <DeleteModal
          onClose={() => setOpenDeleteModal(false)}
          modal={openDeleteModal}
          row={rowValue}
          deleteFunction={() => deleteData(rowValue.id)}
        />
      )}
      <Notifications />
    </div>
  );
};

const mapStateToProps = null;

const mapDispatchToProps = dispatch => ({
  notify: notification => dispatch(newNotification(notification))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AutomaticNotifications);
